const Role = {
  path: "",
  redirect: "/role-management",
  name: "",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  children: [
    {
      path: "/role-management",
      redirect: "/role-management",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      name: "Role",
      meta: {
        requiresAuth: true,
        activeUrl: "/role-management",
        parent: "permission",

        lv: 1,
      },
      children: [
        {
          path: "",
          name: "",
          component: () => import("@/views/pages/manageRole"),
          meta: {
            requiresAuth: true,
            activeUrl: "/role-management",
            parent: "permission",

            lv: 2,
          },
        },
        {
          path: "detail/:id",
          name: "Role Detail",
          component: () => import("@/views/pages/manageRole/Detail.vue"),
          meta: {
            requiresAuth: true,
            isChildren: true,
            activeUrl: "/role-management",
            parent: "permission",

            lv: 2,
          },
        },
      ],
    },
  ],
  meta: { requiresAuth: true },
};
export default Role;
